import { render, staticRenderFns } from "./batchOperation.vue?vue&type=template&id=fa48bd0e&scoped=true"
import script from "./batchOperation.vue?vue&type=script&lang=js"
export * from "./batchOperation.vue?vue&type=script&lang=js"
import style0 from "./batchOperation.vue?vue&type=style&index=0&id=fa48bd0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa48bd0e",
  null
  
)

export default component.exports